var app;
(function (app) {
    var tarefas;
    (function (tarefas) {
        var minhasTarefas;
        (function (minhasTarefas) {
            "use strict";
            var API_ROTULOS = "tasks/tags.json";
            var TYPE_DEFAULT = "AAA";
            var RotulosService = /** @class */ (function () {
                /** @ngInject **/
                function RotulosService($http, properties, $log, $mdDialog, $q) {
                    this.$http = $http;
                    this.properties = properties;
                    this.$log = $log;
                    this.$mdDialog = $mdDialog;
                    this.$q = $q;
                    this.cancelableTag = {
                        id: "ui:cancelable",
                        tasks: [],
                        name: "Cancelável",
                        type: TYPE_DEFAULT,
                        color: "#000000"
                    };
                }
                RotulosService.prototype.load = function (task, manualTags) {
                    var _this = this;
                    if (manualTags === void 0) { manualTags = []; }
                    return this.$http.get(this.properties.apiUrl + "/" + task.context + "/" + API_ROTULOS, { cache: true })
                        .then(function (response) {
                        var _a;
                        try {
                            task.tags = [];
                            if (angular.isArray(response.data)) {
                                (_a = response.data).push.apply(_a, manualTags);
                                response.data.filter(function (tag) { return _this.filterTag(task, tag); })
                                    .forEach(function (tag) { return _this.pushTag(task, tag); });
                                if (task.cancelable) {
                                    _this.pushTag(task, _this.cancelableTag);
                                }
                                task.tags.sort(function (t1, t2) {
                                    if (t1.name > t2.name) {
                                        return 1;
                                    }
                                    if (t1.name < t2.name) {
                                        return -1;
                                    }
                                    return 0;
                                });
                            }
                        }
                        catch (err) {
                            _this.$log.error("Erro ao carregar tags do contexto " + task.context);
                        }
                    });
                };
                RotulosService.prototype.loadManualTags = function () {
                    return this.$http.get(this.properties.apiUrl + "/integracoes-tarefas/api/tags")
                        .then(function (response) {
                        response.data.forEach(function (t) {
                            t.tasks = [t.id];
                            t.type = (!t.type) ? "Manuais" : t.type;
                        });
                        return response.data;
                    }, function () { return []; });
                };
                RotulosService.prototype.create = function (tag) {
                    return this.$http({
                        method: "post",
                        url: this.properties.apiUrl + "/integracoes-tarefas/api/tags",
                        data: tag,
                        transformResponse: function (value) { return value; }
                    })
                        .then(function (response) {
                        return {
                            id: response.data,
                            name: tag.name,
                            tasks: [response.data],
                            color: tag.color,
                            tooltip: tag.tooltip,
                            tenantsPermitidos: tag.tenantsPermitidos,
                            type: "Manuais"
                        };
                    });
                };
                RotulosService.prototype.update = function (tag) {
                    var cmd = {
                        id: tag.id,
                        name: tag.name,
                        color: tag.color
                    };
                    return this.$http.put(this.properties.apiUrl + "/integracoes-tarefas/api/tags/" + tag.id, cmd)
                        .then(function (response) { return response.data; });
                };
                RotulosService.prototype.remove = function (tags) {
                    var _this = this;
                    var deletes = tags.map(function (tag) {
                        return _this.$http.delete(_this.properties.apiUrl + "/integracoes-tarefas/api/tags/" + tag);
                    });
                    return this.$q.all(deletes)
                        .then(function () { return tags; });
                };
                RotulosService.prototype.pushTag = function (task, tag) {
                    if (!tag.type) {
                        tag.type = TYPE_DEFAULT;
                    }
                    task.tags.push(tag);
                };
                RotulosService.prototype.filterTag = function (task, tag) {
                    return tag.tasks.indexOf(task.command) > -1 ||
                        (!!task.etags && tag.tasks.some(function (t) { return task.etags.indexOf(t) > -1; }));
                };
                return RotulosService;
            }());
            minhasTarefas.RotulosService = RotulosService;
            angular
                .module("app.tarefas.minhas-tarefas")
                .service("app.tarefas.minhas-tarefas.RotulosService", RotulosService);
        })(minhasTarefas = tarefas.minhasTarefas || (tarefas.minhasTarefas = {}));
    })(tarefas = app.tarefas || (app.tarefas = {}));
})(app || (app = {}));
